import Skeleton from 'react-loading-skeleton';

import { ReportConversationFormSkeleton } from './ReportConversationForm.styled';

export const SkeletonNewReportChatForm = () => {
    return (
        <ReportConversationFormSkeleton.Container>
            <ReportConversationFormSkeleton.Wrapper>
                <Skeleton height={80} width={'100%'} />
            </ReportConversationFormSkeleton.Wrapper>
            <ReportConversationFormSkeleton.Submit>
                <Skeleton height={38} width={'100%'} />
            </ReportConversationFormSkeleton.Submit>
        </ReportConversationFormSkeleton.Container>
    );
};
